import get from 'lodash/get';

import { filterCurrencyString } from '@/services/forms';

const deductiblesMap: Record<string, string[]> = {
	'f4770f10-d405-407e-af10-d5677f67dbef': [ // Trip Transit Coverage Form
		'C2366.policyPeriodCoverage1.deductible',
		'C2366.policyPeriodCoverageIncludeLoss1.deductible',
		'C2366.perTripCoverage1.deductible',
		'C2366.perTripCoverageIncludeLoss1.deductible'
	],
	'4a4e43b9-e7e1-4dff-bc69-dac17f10a6ef': [ // Contractor's Equipment Coverage Form
		'C1677.unscheduledContractorsEquipment1.deductible',
		'C1677.scheduledContractorsEquipment1.deductible',
		'C1677.equipmentBorrowedFromOthers1.deductible',
		'C1677.equipmentLeasedOrRentedFromOthers1.deductible',
		'C1677.equipmentLoanedToOthers1.deductible',
		'C1677.equipmentLeasedOrRentedToOthers1.deductible'
	],
	'0fc6e4f6-d298-41e3-8cad-3e73e2fcfb18': [ // Motor Truck Cargo Owners Coverage Form
		'C1676.motorTruckCargoOwners1.deductible',
		'C1676.motorTruckCargoOwners.includingSpoilage1.deductible'
	],
	'e051b035-c316-41c5-b10b-7d111c6851ff': [ // Installation Coverage Form
		'C1674.installationCoverage.deductible'
	],
	'd24c87e7-dc38-4bcb-91bd-0644cf210570': [ // Equipment Dealers Coverage Form
		'CM0022.equipmentDealersCoverage.deductible'
	],
	'f0423fcc-9d64-4645-9486-67db06ef8f79': [ // Boat Dealers Coverage Form
		'C2362.deductible'
	],
	'b69c8058-c798-42d3-abbc-3b81bfbb2f3a': [ // Marine Supplies Coverage Form
		'C2363.marineSuppliesCoverage.deductible'
	],
	'd656fa62-869e-4ace-9a53-b2c6c050b30a': [ // Commercial Fine Arts Coverage Form
		'C2365.commercialFineArtsCoverage.deductible'
	],
	'a051f61e-07e2-4216-8024-4ff98dbb5ebe': [], // Accounts Receivable Coverage Form
	'9f8ef936-09e3-430e-a251-68459218ef4f': [], // Signs Coverage Form
	'e58771dd-d148-467b-a11a-2773dfd6981e': [ // Computer Systems Coverage Form
		'C1679.computerSystemsCoverage.basicDeductible'
	],
	'aa87cb12-091b-4337-91cf-7ec076954e22': [] // Inland Marine Optional Coverages Form
};

const multiTableDeductibles: Record<string, { systemId: string; tableId: string }[]> = {
	'174c738f-7e1b-4d5f-abf6-478461fdd113': [ // Commercial Articles Coverage Form
		{ systemId: 'deductible', tableId: 'cm0020.commercialArticlesCoverage.articles' }
	],
	'9236b056-544f-4b67-bfe2-d34301a12d7a': [ // Bailees Customers Coverage Form
		{ systemId: 'deductible', tableId: 'C2367.baileesCustomersCoverage.coverageTypes' }
	],
	'e1a6cd48-e179-4136-a966-03f3ce12be98': [ // Valuable Papers and Records Coverage Form
		{ systemId: 'deductible', tableId: 'CM0066.valuablePapersRecords.coverage' }
	],
	'be89fbf4-8ca4-472f-b3c0-cf45d3956eb8': [ // Special Property Coverage Form
		{ systemId: 'deductible', tableId: 'C1675.specialPropertyCoverage.properties' }
	]
};

export function getInlandMarineChanges( formGuid: string, formData: any ) {
	if ( formData.subcoverages ) {
		return formData.subcoverages.flatMap( ( subForm: any, subcoverageIndex: number ) => {
			const deductibles = deductiblesMap[ subForm.formGuid as string ];
			const multiItemDeductibles = multiTableDeductibles[ subForm.formGuid as string ];

			const mappedDeductibles = deductibles?.map( deductible => {
				const value = get( subForm, deductible, null );

				if ( value && Number( filterCurrencyString( value.value ) ) < 500 ) {
					return {
						parentForm: 'Commercial Inland Marine (C-2395)',
						formName: subForm.formName,
						formGuid: formGuid,
						systemLabel: 'All Other Perils Deductible',
						systemId: deductible,
						fullPath: `subcoverages[${ subcoverageIndex }].${ deductible }`,
						subformPaths: [ `subcoverages[${ subcoverageIndex }]` ],
						oldValue: value.label,
						newValueDisplay: "$1,000",
						newValue: '1000'
					};
				}
			}) || [];

			const mappedMultiItemDeductibles = multiItemDeductibles?.flatMap( table => {
				const tableRecords = get( subForm, table.tableId, [] );

				return tableRecords.map( ( record: any, tableIndex: number ) => {
					const value = get( record, table.systemId, null );

					if ( value && Number( filterCurrencyString( value.value ) ) < 500 ) {
						return {
							parentForm: 'Commercial Inland Marine (C-2395)',
							formName: subForm.formName,
							formGuid: formGuid,
							systemLabel: 'All Other Perils Deductible',
							systemId: table.systemId,
							fullPath: `subcoverages[${ subcoverageIndex }].${ table.tableId }[${ tableIndex }].${ table.systemId }`,
							subformPaths: [ `subcoverages[${ subcoverageIndex }]` ],
							oldValue: value.label,
							newValueDisplay: '$1,000',
							newValue: '1000'
						};
					}
				});
			}) || [];
			
			return [ ...mappedDeductibles, ...mappedMultiItemDeductibles ];
		}).filter( ( a: any ) => a );
	}
	
	return [];
}
